import { useState } from "react";
import type { FormEvent } from "react";
import { useTranslation } from "react-i18next";

import { Button, FloatingLabelInput } from "@aviary";
import { useSignInPathLoginLazyQuery } from "@login/data/queries/SignInPathQuery/SignInPath.query.generated";
import { l } from "@login/locales/i18n";
import { useLocation } from "@shared/react-router-dom/react-router-dom";

import * as styles from "./SSOLogin.styles";

const SSOLoginForm = () => {
  const { t } = useTranslation();

  const { search } = useLocation();
  const urlEmail = new URLSearchParams(search).get("email");

  const [email, setEmail] = useState(urlEmail || "");
  const [execute, { loading }] = useSignInPathLoginLazyQuery();

  const submitSSOLoginForm = (e: FormEvent) => {
    e.preventDefault();

    if (loading) return;
    execute({
      variables: { email },
    }).then(({ data }) => data && window.location.assign(data.signInPath));
  };

  return (
    <form id="sso-login-form" onSubmit={submitSSOLoginForm} autoComplete="autoComplete">
      <FloatingLabelInput
        maxLength={255}
        name="email"
        type="email"
        autoComplete="email"
        id="email"
        autoFocus
        label={t(l.login.EmailAddress)}
        required
        value={email}
        handleChange={e => setEmail(e.target.value)}
      />
      <Button
        intention="primary"
        isOutlined={false}
        css={styles.submitButton}
        type="submit"
        disabled={loading}
        isLoading={loading}
      >
        {t(l.login.SignIn)}
      </Button>
    </form>
  );
};

export { SSOLoginForm };
